import React, { Component } from 'react';
import Aux from '../../../components/Hoc/Aux';
import Reasons from '../../../components/Reasons/Reasons';
import ReasonsLookAgain from '../../../components/Reasons/ReasonsSmallBizLookAgain';
import National from '../../../components/National/National';
import Testimonials from '../../../components/Testimonials/Testimonials';

class SmallBusiness extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Prospect - Small Group',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Small Group',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        {this.props.lookagain ?
          <ReasonsLookAgain /> :
          <Reasons />
        }
        <National />
        {this.props.lookagain ?
          <Testimonials heading='“CDPHP checks all the boxes, and we couldn’t be happier with our experience.”' slides='smallbiz' smallBiz='true' /> :
          <Testimonials heading='&ldquo;CDPHP treats you like someone they know and care about.&rdquo;' slides='group' />
        }
      </Aux>
    );
  }
}

SmallBusiness.propTypes = { // validate props expected
};

export default SmallBusiness;
